const quickLinks = [
  { label: '热门连载', href: '#featured' },
  { label: '题材分类', href: '#categories' },
  { label: '独家抢先看', href: '#exclusive' },
  { label: '本周更新榜', href: '#rank' },
  { label: '常见问题', href: '#faq' },
  { label: '关于我们', href: '#about' },
];

const genres = ['热血战斗', '奇幻异界', '悬疑推理', '恋爱日常', '轻松搞笑', '科幻星际', '冒险热血', '校园青春'];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-2-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl text-accent-400">喵趣漫画网</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              汉化连载 · 独家翻译 · 抢先看。未删减高清原版，与热门作品同步更新。
            </p>
            <div className="mt-4 flex items-center gap-2">
              {[
                { icon: 'ri-wechat-line', label: '微信' },
                { icon: 'ri-weibo-line', label: '微博' },
                { icon: 'ri-bilibili-line', label: '哔哩哔哩' },
                { icon: 'ri-mail-line', label: '邮箱' },
              ].map((s) => (
                <a
                  key={s.label}
                  href="#about"
                  aria-label={s.label}
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-background-700 text-background-300 transition-colors hover:border-primary-400 hover:text-primary-400"
                >
                  <i className={`${s.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <nav aria-label="快速导航" className="flex flex-col gap-3">
            <h3 className="text-sm font-bold text-background-50">快速导航</h3>
            {quickLinks.map((l) => (
              <a key={l.label} href={l.href} className="text-sm text-background-300 transition-colors hover:text-accent-400">
                {l.label}
              </a>
            ))}
          </nav>

          <nav aria-label="热门题材" className="flex flex-col gap-3">
            <h3 className="text-sm font-bold text-background-50">热门题材</h3>
            {genres.map((g) => (
              <a key={g} href="#categories" className="text-sm text-background-300 transition-colors hover:text-accent-400">
                {g}
              </a>
            ))}
          </nav>

          <div className="flex flex-col gap-3">
            <h3 className="text-sm font-bold text-background-50">联系我们</h3>
            <p className="flex items-center gap-2 text-sm text-background-300">
              <i className="ri-mail-line text-accent-400"></i>
              support@miaoqumanga.com
            </p>
            <p className="flex items-center gap-2 text-sm text-background-300">
              <i className="ri-time-line text-accent-400"></i>
              客服在线 10:00 - 22:00
            </p>
            <p className="flex items-start gap-2 text-sm text-background-300">
              <i className="ri-customer-service-2-line mt-0.5 text-accent-400"></i>
              连载问题、合作投稿、追更订阅
              均可通过上方表单联系
            </p>
            <a
              href="#about"
              className="mt-2 inline-flex w-fit items-center whitespace-nowrap rounded-full bg-accent-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
            >
              <i className="ri-mail-send-line mr-1.5 text-base"></i>
              订阅追更
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-800 pt-6 sm:flex-row">
          <p className="text-xs text-background-400">© 2026 喵趣漫画网 · 仅供交流学习，请支持正版漫画</p>
          <button
            type="button"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="inline-flex items-center whitespace-nowrap rounded-full bg-background-800 px-4 py-2 text-xs font-semibold text-background-100 transition-colors hover:bg-primary-500"
          >
            <i className="ri-arrow-up-line mr-1 text-sm"></i>
            回到顶部
          </button>
        </div>
      </div>
    </footer>
  );
}